const getDrugVariantForDoseType = (drugVariant: string, doseType: string) => {
  if (doseType === 'micro') {
    return `${drugVariant.replace('_micro', '')}_micro`;
  }
  return drugVariant.replace('_micro', '');
};

const getStrengthVariantForDrugAndDose = (drugVariant: string, doseType: string) => {
  if (doseType === 'micro') {
    return drugVariant.includes('semaglutide') ? '0_1mg' : '1mg';
  }
  return drugVariant.includes('semaglutide') ? '0_25mg' : '2_5mg';
};

const drugVariantIsMicro = (drugVariant: string) => {
  return drugVariant?.includes('micro');
};

export { getDrugVariantForDoseType, getStrengthVariantForDrugAndDose, drugVariantIsMicro };
